import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class NewMemberRequest {
  constructor(init) {
    // console.log('NewMemberRequestInit', init)
    if (isNil(init)) return undefined

    this._organization_name = init.organization_name
    this._employee_id = init.employee_id
    this._user_email = init.user_email
    this._user_name = init.user_name
    this._user_phone_number = init.user_phone_number
    this._users_job_title = init.users_job_title

    this._for_dependent = init.for_dependent
    this._first_name = init.first_name
    this._last_name = init.last_name
    this._dob = init.dob
    this._gender = init.new_member_request_gender
    this._cardholder_id = init.new_member_request_cardholder_id
    this._person_code = init.new_member_request_person_code
    this._group_name = init.group_name
    this._coverage_type = init.coverage_type
    this._plan_start_date = init.plan_start_date
    this._plan_end_date = init.plan_end_date

    this._address_1 = init.address_1
    this._address_2 = init.address_2
    this._city = init.city
    this._state = init.new_member_request_state
    this._zip_code = init.zip_code

    this._address_type = init.address_type
    this._phone_number = init.phone_number
    this._phone_number_type = init.phone_number_type
    this._request_details = init.request_details
  }

  static shape = {
    organization_name: PropTypes.string,
    employee_id: PropTypes.string,
    user_email: PropTypes.string,
    user_name: PropTypes.string,
    user_phone_number: PropTypes.string,
    users_job_title: PropTypes.string,
    for_dependent: PropTypes.bool,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    dob: PropTypes.string,
    gender: PropTypes.string,
    cardholder_id: PropTypes.string,
    person_code: PropTypes.string,
    group_name: PropTypes.string,
    coverage_type: PropTypes.string,
    plan_start_date: PropTypes.string,
    plan_end_date: PropTypes.string,
    address_1: PropTypes.string,
    address_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip_code: PropTypes.string,
    address_type: PropTypes.string,
    phone_number: PropTypes.string,
    phone_number_type: PropTypes.string,
    request_details: PropTypes.string
  }

  get organization_name() {
    return this._organization_name
  }

  get employee_id() {
    return this._employee_id
  }

  get user_email() {
    return this._user_email
  }

  get user_name() {
    return this._user_name
  }

  get user_phone_number() {
    return this._user_phone_number
  }

  get users_job_title() {
    return this._users_job_title
  }

  get for_dependent() {
    return this._for_dependent
  }

  get first_name() {
    return this._first_name
  }

  get last_name() {
    return this._last_name
  }

  get dob() {
    return this._dob
  }

  get gender() {
    return this._gender
  }

  get cardholder_id() {
    return this._cardholder_id
  }

  get person_code() {
    return this._person_code
  }

  get group_name() {
    return this._group_name
  }

  get coverage_type() {
    return this._coverage_type
  }

  get plan_start_date() {
    return this._plan_start_date
  }

  get plan_end_date() {
    return this._plan_end_date
  }

  get address_1() {
    return this._address_1
  }

  get address_2() {
    return this._address_2
  }

  get city() {
    return this._city
  }

  get state() {
    return this._state
  }

  get zip_code() {
    return this._zip_code
  }

  get address_type() {
    return this._address_type
  }

  get phone_number() {
    return this._phone_number
  }

  get phone_number_type() {
    return this._phone_number_type
  }

  get request_details() {
    return this._request_details
  }
}

export default NewMemberRequest
